import { render, staticRenderFns } from "./Socialmedia.vue?vue&type=template&id=af0b0b72"
import script from "./Socialmedia.vue?vue&type=script&lang=js"
export * from "./Socialmedia.vue?vue&type=script&lang=js"
import style0 from "./Socialmedia.vue?vue&type=style&index=0&id=af0b0b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports